import {backgroundImageStyle} from '@/utils/background-image'
import {mapActions, mapGetters} from 'vuex'

// Актуальний PDF з адмінки (pricing-items); fallback якщо API ще не відповів
const FALLBACK_PRICE_PDF =
    'https://api.karbosnab.com/storage/files/pricing_items/c4/ca/JkJtZpvWsV9eRbh6KzgbB5tdiRi3ks19RwvHcMhc.pdf'

export default {
    name: "main-banner",
    props: {
        item: {}

    },
    data() {
        return {}
    },
    watch: {
        item: {
            immediate: true,
            handler(val) {
                if (val && typeof val === 'object' && val.addv !== undefined) {
                    this.ensurePricingList()
                }
            },
        },
    },
    computed: {
        ...mapGetters({
            pricingLists: 'articles/pricingLists',
        }),
        bgImage: function () {
            return this.item.bannerImage || this.item.image
        },
        bannerStyle() {
            return backgroundImageStyle(this.bgImage)
        },
        // Прайс з pricing-items (не addv.link — там реклама/фільтри)
        priceDownloadUrl() {
            if (this.item?.priceFile) {
                return this.item.priceFile
            }
            const lists = Array.isArray(this.pricingLists) ? this.pricingLists : []
            const withFile = lists.find((entry) => entry && entry.filePath)
            return withFile?.filePath || FALLBACK_PRICE_PDF
        },
    },
    methods: {
        ...mapActions({
            getPricingLists: 'articles/GET_PRICING_LIST',
        }),
        stripHtml(html) {
            if (!html) return ''
            return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        },
        ensurePricingList() {
            const lists = Array.isArray(this.pricingLists) ? this.pricingLists : []
            if (!lists.length) {
                this.getPricingLists().catch(() => {})
            }
        },
    }
}
